import React from "react";
import { Cpu, ScanEye, FileCheck2, ShieldX } from "lucide-react";

const PILLARS = [
  {
    icon: Cpu,
    title: "Erased the right way",
    body: "Each drive is wiped with the manufacturer's own firmware sanitize commands — the gold standard recommended by NIST — not a generic one-size-fits-all overwrite.",
  },
  {
    icon: ScanEye,
    title: "Independently verified",
    body: "After every wipe we read the drive's real bytes directly from the disk to confirm the data is actually gone. We verify the result — we never assume it.",
  },
  {
    icon: FileCheck2,
    title: "Certified with proof",
    body: "Each device gets a tamper-evident, digitally signed certificate recording exactly what was erased, how, and the result — proof you can stand behind.",
  },
];

const WhyErasure = () => {
  return (
    <section id="why" className="relative bg-white font-body">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-brand-bg px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-brand-plum">
            Why it matters
          </span>
          <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-brand-plum sm:text-4xl lg:text-5xl">
            &ldquo;Is my old data <span className="text-brand-gradient">really gone?</span>&rdquo;
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink sm:text-lg">
            When a device is resold, that&apos;s the single biggest worry — for the previous owner, the buyer,
            and the reseller. Furloop Poofed removes it completely: every drive is erased, verified, and
            certified before the device moves forward. If a wipe can&apos;t be confirmed, the device fails and
            never moves on.
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {PILLARS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col rounded-2xl border border-line bg-white p-6 transition-all hover:-translate-y-1 hover:border-brand-orchid hover:shadow-xl hover:shadow-brand-plum/5"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-wash text-brand-magenta ring-1 ring-brand-orchid/30">
                <Icon className="h-6 w-6" />
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold text-brand-plum">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted">{body}</p>
            </div>
          ))}
        </div>

        {/* fail-closed callout */}
        <div className="mt-8 flex items-start gap-3 rounded-2xl border border-danger/30 bg-danger/5 p-5">
          <ShieldX className="mt-0.5 h-5 w-5 shrink-0 text-danger" />
          <p className="text-sm leading-relaxed text-brand-plum">
            <span className="font-semibold">No &ldquo;assume success.&rdquo;</span> If any drive can&apos;t be
            confirmed clean, the certificate is marked <span className="font-semibold text-danger">failed</span>{" "}
            and the device never moves forward.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyErasure;
